<div class="home-page-container">
      <!-- Auto breadcrumbs using signals -->
  <app-breadcrumbs appAutoBreadcrumbs></app-breadcrumbs>
  <div>
    <div *ngIf="(headerData$ | async)?.title && !hidePageHeader" class="title-container">
      <app-page-header 
        [title]="(headerData$ | async)?.title" 
        [subtitle]="(headerData$ | async)?.subtitle"
        [groupName]="groupName" 
        [groupNumber]="groupNumber">
      </app-page-header>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>
